import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { useLocalization } from '@ui-framework/index';
import { getMonth } from './constants';

function MonthNavigator({ hidePrev, goPrev, cursor, goNext }) {
  const { formatMessage } = useLocalization();
  const shortMonth = getMonth({
    formatMessage,
    number: 1 + cursor.month(),
  })?.longLabel;
  const year = cursor.format('YYYY');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        flexWrap: 'wrap',
      }}>
      {!hidePrev ? (
        <Tooltip
          arrow
          placement="top"
          title={
            <FormattedMessage
              id="PREVIOUS_MONTH"
              defaultMessage="Previous Month"
            />
          }>
          <IconButton color="primary" onClick={goPrev} size="small">
            <ChevronLeft />
          </IconButton>
        </Tooltip>
      ) : (
        <Box sx={{ width: 40, flexShrink: 0 }} />
      )}
      <Typography variant="subtitle1" fontWeight={600} noWrap>
        {shortMonth} {year}
      </Typography>
      <Tooltip
        arrow
        placement="top"
        title={
          <FormattedMessage id="NEXT_MONTH" defaultMessage="Next Month" />
        }>
        <IconButton color="primary" onClick={goNext} size="small">
          <ChevronRight />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default MonthNavigator;
